module.exports = __webpack_public_path__ + "assets/img/package-woman-work.1149c4df.svg";